import Vue from 'vue'
import Router from 'vue-router'
let routerOpt = {
    mode: 'history',
    routes: [{
        path: '/404',
        component: resolve => require(['@/components/common/404/404.vue'], resolve),
        hidden: true
    },/* {
        path: '/',
        // component: resolve => require(['@/components/conf/select-shop/select-shop.vue'], resolve),
        redirect: '/login',
        hidden: true
    },*/ {
        path: '/login',
        component: resolve => {
          if(process.env.NODE_ENV !== 'production'){
            return require(['@/components/conf/login/login-test.vue'], resolve)
          }
          return require(['@/components/conf/login/login.vue'], resolve)
        },
        name: '登陆',
        hidden: true
    }, {
        path: '/register',
        component: resolve => require(['@/components/conf/register/register.vue'], resolve),
        name: '注册',
        hidden: true
    }, {
        path: '/register/protocol',
        component: resolve => require(['@/components/conf/protocol/protocol.vue'], resolve),
        name: '注册服务协议',
        hidden: true
    }, {
        path: '/no-right',
        component: resolve => require(['@/components/conf/no-right/no-right.vue'], resolve),
        name: '登陆无权限',
        hidden: true
    }, {
        path: '/find-password',
        component: resolve => require(['@/components/conf/find-password/find-password.vue'], resolve),
        name: '找回密码',
        hidden: true
    }]
}
Vue.use(Router)
const router = new Router(routerOpt)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js